<template>
    <div>

        <h2 style="margin:10px 0px 10px 0px;">Settings</h2>

        <p>
            Your account settings are shown here. Additional configuration options (password reset, preferences, etc.) are under construction.
        </p>

        <table class="table table-bordered" style="color:#666;background-color:#fff;font-size:16px;">
            <tr><td style="width:50%">E-mail address:</td><td  style="width:50%">{{profile.username}}</td></tr>
            <tr><td>Display name:</td><td>{{profile.dispname}}</td></tr>
        </table>
       
    </div>
</template>

<script>
  export default {
    name: 'account-settings',
    components: {
      
    },
    data() {
    },
      mounted() {
        //this.$refs["username"].focus()
      },
    computed: {
        profile() {
            return this.$store.state.profile
        },
        count() {
            
        }
    },
    methods: {
    }
  }
</script>

<style scoped>
    h2 {
        font-size:24px;
    }
    table th {
        border-top:none;
        padding:5px 0px;
    }
    table td {
        padding:5px;
    }
</style>


